import { Divider } from '@mantine/core';
import styles from './Modal.module.css';

interface Props {
  title: string;
  subTitle?: string;
  icon?: string;
  iconBackground?: string;
}

function ModalHeader({ icon, subTitle, title, iconBackground = '#B5BBC133' }: Props) {
  return (
    <>
      <div className={styles.modalHeaderContainer}>
        {icon && (
          <div style={{ backgroundColor: iconBackground }} className={styles.modalHeaderIcon}>
            <span className={styles.modalHeaderIconText}>{icon}</span>
          </div>
        )}
        <div className={styles.modalHeaderTextContainer}>
          <div className={styles.modalHederTitle}>{title}</div>
          {subTitle && <div className={styles.modalHeaderSubTitle}>{subTitle}</div>}
        </div>
      </div>
      <div className={styles.dividerContainer}>
        <Divider />
      </div>
    </>
  );
}

export default ModalHeader;
